module.exports = ".flex {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/order-form-recount-confirm/order-form-recount-confirm.component.scss
// module id = ./src/app/dashboard/order-form-recount-confirm/order-form-recount-confirm.component.scss
// module chunks = main